import { supabase } from './supabase';

export async function invokeSyncRIDBFacilities() {
  try {
    console.log('Invoking sync-ridb-facilities function...');
    
    const { data, error } = await supabase.functions.invoke('sync-ridb-facilities', {
      body: {},
    });

    if (error) {
      console.error('Function error:', error);
      throw error;
    }

    console.log('✓ Sync completed!', data);
    return data;
  } catch (error) {
    console.error('Error invoking sync function:', error);
    throw error;
  }
}

export async function checkFacilitiesCount() {
  try {
    const { count, error } = await supabase
      .from('facilities')
      .select('*', { count: 'exact', head: true });

    if (error) throw error;
    return count || 0;
  } catch (error) {
    console.error('Error checking facilities count:', error);
    return 0;
  }
}
